import { VenetianMask, X } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '@fortem-monorepo/react-ui'

import { ImpersonationModal } from '@/components/dialogs/ImpersonationModal'
import { useUserContext } from '@/index'

export interface ImpersonateProps {}

export const Impersonate: React.FC<ImpersonateProps> = ({}) => {
  const { isImpersonating, setShowImpersonationModal, stopImpersonating } = useUserContext()

  return (
    <>
      <ImpersonationModal />
      {isImpersonating && (
        <div
          className={
            'z-50 fixed bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-1 overflow-hidden pl-1 pr-1 py-1 rounded-full bg-primary text-white text-sm select-none'
          }
        >
          <button
            onClick={() => setShowImpersonationModal(true)}
            className={
              'flex items-center gap-2 cursor-pointer px-2 py-1 rounded-full transition-colors hover:bg-neutral-500 hover:text-neutral-70 font-medium '
            }
          >
            <VenetianMask size={20} />
            IMPERSONATING
          </button>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={() => stopImpersonating()}
                className={
                  'cursor-pointer rounded-full flex items-center p-1 bg-neutral-500  transition-colors hover:bg-red-500 hover:text-white'
                }
              >
                <X size={20} strokeWidth={3} />
              </button>
            </TooltipTrigger>
            <TooltipContent>Stop impersonating</TooltipContent>
          </Tooltip>
        </div>
      )}
    </>
  )
}
